export const environment = {
  production: true,
  buildId: '3572920932522741',
  configFile: 'config.json',
};
